(function($) {

	$.fn.buttonColumn = function(options) {
		// build main options before element iteration
		var opts = $.extend( {}, $.fn.buttonColumn.defaults, options);

		return this.each(function() {
			var $this = $(this);
			// build element specific options
            var eOpts = $.metadata ? $.extend( {}, opts, $this.metadata()) : opts;
            eOpts = $.fn.dataset ? $.extend( {}, eOpts, $this.dataset()) : eOpts;

            var maxWidth = 0;
            $this.find(".button").each(function() {
                if($(this).width() > maxWidth)
                {
                    maxWidth = $(this).width();
                }
            }).each(function() {
                if(maxWidth > 0) {
                    $(this).width(maxWidth);
                }
            });
        });
	};

})(jQuery);